// SearchToken holds a single search term plus metadata. All
// instance variables should be considered immutable after being
// initialized in the constructor. Instead of modifying instance vars,
// create a new instance with the desired values.
export default class SearchToken {
  constructor(text, index, startOffset, endOffset) {
    this.kind = this.kind.bind(this);
    this.text = text;
    this.index = index;
    this.startOffset = startOffset;
    this.endOffset = endOffset;
    if (this.isWhitespace()) {
      this.text = this.text.replace(/\s/g, "\u2001");
    } else {
      this.text = this.text.replace(/\u2001/g, " ");
    }
  }

  key() {
    return this.text.match(/^[^:]+/i)[0] || "";
  }

  value() {
    const r = this.text.match(/^[^:]+:(?:'([^']+)'|"([^"]+)"|(\S+))/i);
    return (r && (r[1] || r[2] || r[3])) || "";
  }

  isComplete() {
    return !!this.text.match(/^[^:]+:(?:'([^']+)'|"([^"]+)"|(\S+))/i);
  }

  isWhitespace() {
    return !!this.text.match(/^\s+$/);
  }

  isPlaceholder() {
    return this.text === "...";
  }

  kind() {
    if (this.isWhitespace()) {
      return "whitespace";
    }
    if (this.isComplete()) {
      return "complete";
    }
    return "incomplete";
  }

  cloneWithNewText(newText) {
    return new SearchToken(
      newText,
      this.index,
      this.startOffset,
      this.startOffset + newText.length,
    );
  }

  cloneWithNewKey(newKey) {
    let currentValue = this.value().trim();

    if (currentValue && !currentValue.match(/^"[^"]*"$/)) {
      currentValue = `"${currentValue}"`;
    }

    return this.cloneWithNewText(
      currentValue ? [newKey, currentValue].join(":") : newKey,
    );
  }

  cloneWithNewValue(newValue) {
    return this.cloneWithNewText(
      [this.key(), `"${newValue.replace(/"/g, "'")}"`].join(":"),
    );
  }

  valueStartOffset() {
    // Placeholders like params.: where the cursor needs to start after the dot
    let match;
    if ((match = this.text.match(/^([^:]+\.):/i))) {
      return match[1].length;
    }

    // Surrounded values like foo:"bar", where cursor needs to be inside quote
    if ((match = this.text.match(/^[^:]+:("|')/i))) {
      return match[0].length;
    }
    return 0;
  }

  valueEndOffset() {
    // Placeholders like params.: where the cursor needs to start after the dot
    let match;
    if ((match = this.text.match(/^([^:]+\.):/i))) {
      return match[1].length - this.text.length;
    }
    // Surrounded values like foo:"bar", where selection ends right before the final quote
    if ((match = this.text.match(/("|')$/i))) {
      return -1;
    }
    return 0;
  }
}
